'use strict';

import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isEmpty } from 'lodash';
import classNames from 'classnames';

import ProgressStepIndicator from '../ProgressStepIndicator';
import Loader from '../../Loader';
import Alert from '../../Alert';
import OTButton from '../../tag/OTButton';
import OTButtonGroup from '../../tag/OTButtonGroup';

import Logger from '../../../utils/Logger';
import ErrorTooltip from '../../ErrorTooltip';
import { nonNullGet } from '../../../utils/Functions';

const { id: module_id } = module;
let logger = Logger(module_id);

class AgreementPage5 extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.getElementById('skip-to-content').focus();
  }

  cancel = (event) => {
    event.preventDefault();
    this.props.triggerCancelModal();
  };

  render() {
    let {
      userInfo,
      agreementError,
      sendingAgreement,
      completeAgreement,
      hideAgreementError,
      intl,
    } = this.props;

    let emailErrors = nonNullGet(this.props, 'errors.email', []);
    let emailConfirmErrors = nonNullGet(this.props, 'errors.confirmEmail', []);
    let phoneErrors = nonNullGet(this.props, 'errors.phone', []);
    let phoneConfirmErrors = nonNullGet(this.props, 'errors.confirmPhone', []);

    let emailFieldClassNames = classNames('control-group', {
      error: emailErrors.length > 0,
    });
    let emailConfirmFieldClassNames = classNames('control-group', {
      error: emailConfirmErrors.length > 0,
    });
    let phoneFieldClassNames = classNames('control-group', {
      error: phoneErrors.length > 0,
    });
    let phoneConfirmFieldClassNames = classNames('control-group', {
      error: phoneConfirmErrors.length > 0,
    });

    let emailFieldsOptions = {},
      phoneFieldsOptions = {};
    if (userInfo && userInfo.noEmail) emailFieldsOptions['hidden'] = 'hidden';

    if (!userInfo) {
      return (
        <div>
          <Loader />
        </div>
      );
    }

    let address = isEmpty(userInfo.address)
      ? intl.formatMessage({ id: 'no.address.information' })
      : userInfo.address;

    return (
      <div className="ot-agreement-page">
        <h1 className="ot-agreement-title">
          <FormattedMessage id={`${module_id}.title`} />
        </h1>
        <ProgressStepIndicator total={3} current={3} />
        <p className="infoTitle">
          <b>
            <FormattedMessage id={`${module_id}.infotitle`} />
          </b>
        </p>
        <div className="row-fluid">
          <div className="span6 infotext">
            <p>
              <FormattedMessage id={`${module_id}.infotext2`} />
            </p>
            <p>
              <FormattedMessage id={`${module_id}.infotext3`} />
            </p>
            <p>
              <FormattedMessage id={`${module_id}.infotext4`} />
            </p>
            <p>
              <FormattedMessage id={`${module_id}.infotext5`} />
            </p>
          </div>
          {/* First 3 fields are not editable in any case, so we are not making these into fields*/}
          <div className="span6 ot-agreement-form">
            <div className="ot-agreement-field-group">
              {/* Hetu */}
              <div className="control-group">
                <label
                  className="control-label"
                  aria-disabled="true"
                  htmlFor="hetu"
                >
                  <span className="label_text">
                    <FormattedMessage id={'social.security.number'} />
                  </span>
                  <div className="controls">
                    <input
                      id="hetu"
                      disabled
                      className={'inactive-input'}
                      value={userInfo.hetu}
                    />
                  </div>
                </label>
              </div>

              {/* Full name */}
              <div className="control-group">
                <label
                  className="control-label"
                  aria-disabled="true"
                  htmlFor="name"
                >
                  <span className="label_text">
                    <FormattedMessage id={'name'} />
                  </span>
                  <div className="controls">
                    <input
                      id="name"
                      disabled
                      className={'inactive-input'}
                      value={userInfo.name}
                    />
                  </div>
                </label>
              </div>

              {/* Address */}
              <div className="control-group">
                <label
                  htmlFor="address"
                  aria-disabled="true"
                  className="control-label"
                >
                  <span className="label_text">
                    <FormattedMessage id={'address'} />
                  </span>
                  <div className="controls">
                    {isEmpty(userInfo.address) ? (
                      <FormattedMessage
                        id={'no.address.information'}
                        values={{
                          icon: (
                            <i className="icon-external-link fa ot-icon ot-icon--blue" />
                          ),
                          a: (msg) => (
                            <a
                              href="https://www.posti.fi/fi/henkiloille/muuttoilmoitus/"
                              target="_blank"
                              rel="noreferrer noopener"
                            >
                              {msg}
                            </a>
                          ),
                        }}
                      />
                    ) : (
                      <input
                        id="address"
                        disabled
                        className={'inactive-input'}
                        value={address}
                      />
                    )}
                  </div>
                </label>
              </div>
            </div>

            <div className="ot-agreement-field-group">
              {/* Phone number */}
              <label htmlFor="phone" className="control-label">
                <span aria-disabled="true" className="label_text">
                  <FormattedMessage id={'phone.number'} />
                </span>
                <span className="required" />
                <div className="controls">
                  <input
                    {...phoneFieldsOptions}
                    className={phoneFieldClassNames}
                    aria-required="true"
                    id="phone"
                    type="text"
                    onChange={this.props.handleUserInfoChange}
                    onKeyUp={this.props.handleUserInfoPhone}
                    name="phone"
                    value={userInfo.phone}
                  />
                  {phoneErrors.length > 0 && (
                    <div className="ot-agreement-error">
                      {phoneErrors.map((error, index) => (
                        <ErrorTooltip key={index} error={error} />
                      ))}
                    </div>
                  )}
                </div>
              </label>

              {/* Confirm phone number */}
              {userInfo.phoneFieldEdited ? (
                <label htmlFor="confirmPhone" className="control-label">
                  <span aria-disabled="true" className="label_text">
                    <FormattedMessage id={'confirm.phone.number'} />
                  </span>
                  <span className="required" />
                  <div className="controls">
                    <input
                      {...phoneFieldsOptions}
                      className={phoneConfirmFieldClassNames}
                      type="text"
                      aria-required="true"
                      id="confirmPhone"
                      onChange={this.props.handleUserInfoChange}
                      onKeyUp={this.props.handleUserInfoPhone}
                      name="confirmPhone"
                      value={userInfo.confirmPhone}
                    />
                    {phoneConfirmErrors.length > 0 && (
                      <div className="ot-agreement-error">
                        {phoneConfirmErrors.map((error, index) => (
                          <ErrorTooltip key={index} error={error} />
                        ))}
                      </div>
                    )}
                  </div>
                </label>
              ) : (
                <></>
              )}
            </div>

            <div className="ot-agreement-field-group">
              {/* No email -checkbox */}
              <div className="control-group">
                <label htmlFor="noemail" className="checkbox">
                  <input
                    type="checkbox"
                    id="noemail"
                    onChange={this.props.handleUserInfoChange}
                    name="noEmail"
                    value={userInfo.noEmail}
                  />
                  <span className="control-label">
                    <FormattedMessage
                      className="control-label"
                      id={'no.email'}
                    />
                  </span>
                </label>
                {!userInfo.noEmail && (
                  <>
                    {/* Email */}
                    <label
                      {...emailFieldsOptions}
                      htmlFor="email"
                      className="control-label"
                    >
                      <span aria-disabled="true" className="label_text">
                        <FormattedMessage id={'email'} />
                      </span>
                      <div className="controls">
                        <input
                          className={emailFieldClassNames}
                          id="email"
                          type="text"
                          onChange={this.props.handleUserInfoChange}
                          onKeyUp={this.props.handleUserInfoEmail}
                          name="email"
                          value={userInfo.email}
                        />
                        {emailErrors.length > 0 && (
                          <div className="ot-agreement-error">
                            {emailErrors.map((error, index) => (
                              <ErrorTooltip key={index} error={error} />
                            ))}
                          </div>
                        )}
                      </div>
                    </label>
                    {/* Confirm email */}
                    <label
                      {...emailFieldsOptions}
                      htmlFor="confirmEmail"
                      className="control-label"
                    >
                      <span aria-disabled="true" className="label_text">
                        <FormattedMessage id={'confirm.email'} />
                      </span>
                      <div className="controls">
                        <input
                          className={emailConfirmFieldClassNames}
                          id="confirmEmail"
                          type="text"
                          onChange={this.props.handleUserInfoChange}
                          onKeyUp={this.props.handleUserInfoEmail}
                          name="confirmEmail"
                          value={userInfo.confirmEmail}
                        />
                        {emailConfirmErrors.length > 0 && (
                          <div className="ot-agreement-error">
                            {emailConfirmErrors.map((error, index) => (
                              <ErrorTooltip key={index} error={error} />
                            ))}
                          </div>
                        )}
                      </div>
                    </label>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {agreementError && (
          <Alert dismiss={{ func: hideAgreementError }}>
            <FormattedMessage id="agreement.completion.error" />
          </Alert>
        )}
        <div className="ot-agreement-buttons row-fluid text-center">
          <OTButtonGroup fullWidth type={'big'} expectedCount={2}>
            <OTButton onClick={this.cancel}>
              <FormattedMessage id={'abort'} />
            </OTButton>
            <OTButton disabled={sendingAgreement} onClick={completeAgreement}>
              <FormattedMessage id={'accept'} />
            </OTButton>
          </OTButtonGroup>
        </div>
      </div>
    );
  }
}

export default injectIntl(AgreementPage5);
